import { Component, Input } from '@angular/core';

@Component({
    selector: 'cs-shared-manager-goal-result',
    templateUrl: './goal-result.component.html'
})
export class SharedManagerGoalResultComponent {
    @Input() isMinimumQualifierEnabled: boolean;
    @Input() goalAchievedUsers: any;
    @Input() goalAchievedDetails: any;
    @Input() endDate: string;

    constructor() { }

    calculateAchievedPercentage(selectedCount, achievedCount) {
        return (selectedCount && achievedCount) ? ((achievedCount / selectedCount) * 100) : 0;
    }
}